import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { Spinner } from '../components/atoms/Spinner/Spinner';

/**
 * Un componente que maneja rutas públicas como /login o /register.
 * Verifica el estado de autenticación del usuario con Firebase.
 * - Si el usuario está autenticado, lo redirige al dashboard.
 * - Si el usuario no está autenticado, renderiza el componente hijo (a través de <Outlet />).
 * - Muestra un indicador de carga mientras se verifica el estado.
 */
export const PublicRoute: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    if (loading) {
        return <div className="flex justify-center items-center h-screen"><Spinner size="large" /></div>;
    }

    return user ? <Navigate to="/dashboard" replace /> : <Outlet />;
};
